import React from "react";
import { AboutSection } from "../components/AboutSection";
import { CurrentlyWorkingOn } from "../components/CurrentlyWorkingOn";
import { FeaturedThought } from "../components/FeaturedThought";
import { Hero } from "../components/Hero";
import { ProjectsSection } from "../components/ProjectsSection";
import { ReceiptsSection } from "../components/ReceiptsSection";
import { usePageTitle } from "../hooks/usePageTitle";
export function Home() {
  usePageTitle();

  // Home → About → Selected Work → Now → Receipts → Thoughts → Contact (footer)
  return <main id="main-content" tabIndex={-1} data-id="element-509" data-mp="24ivcnhuguze2">
      <Hero data-id="element-510" data-mp="29fvh5obo3u32" />
      <AboutSection data-id="element-511" data-mp="29fc009tud9q3" />
      <ProjectsSection data-id="element-512" data-mp="29ettmkdgtf4g" />
      <CurrentlyWorkingOn data-id="element-513" data-mp="29ihmdhb35xi4" />
      <ReceiptsSection data-id="element-514" data-mp="2di8eppg9glor" />
      <FeaturedThought data-id="element-515" data-mp="2dii1l460ecq8" />
    </main>;
}